import { createApp } from 'vue'
import App from './App.vue'
import '@/styles/style.scss'
import './common/ga.js'

createApp(App).mount('#app')
